// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popcorn-video[data-v-9654222e]{max-width:600px}.popcorn-explainer-content[data-v-9654222e]{max-width:500px}ul[data-v-9654222e]{list-style:none;padding:0}.li-icon[data-v-9654222e]{height:2rem;width:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
